<template>
  <div>
    <template v-if="useActablStyles">
      <v-app
        style="background: linear-gradient(64.7deg, #FFFFFF 23.24%, #E5EDFB 57.05%, #FEEADD 94.45%)"
      >
        <div class="wrapper">
          <div :class="{ bar: true }" />
          <div
            class="release"
            style="top: 32; right: 180"
          >
            <a
              href="https://profitsword.na1.teamsupport.com/knowledgeBase/25456071"
              target="_blank"
              class="group default-color"
            >
              Release notes
            </a>
          </div>
          <div
            class="actablStylesContainer2"
            :class="{ alert: isPsAlertVisible }"
          >
            <div class="logo">
              <div style="display: flex; align-items: center; padding-top: 25px">
                <img :src="NewPSLogo">
                <div style="padding-left: 3%; padding-bottom: 3%">
                  <div>
                    <img :src="ProfitswordLogo">
                    <div class="logo-line" />
                  </div>
                  <!-- by actbl -->
                  <div
                    style="
                    position: relative;
                    display: flex;
                    align-items: center;
                    padding-left: 75%;
                  "
                  >
                    <img
                      :src="ByPSLogo"
                      alt="by"
                    >
                    <img
                      :src="ActblPSLogo"
                      alt="actbl"
                    >
                  </div>
                </div>
              </div>
            </div>
            <div />
            <div style="margin-right: auto; margin-bottom: -10px;">
              <h4 style="margin: 10px 0px;">
                Reset the password for your account.
              </h4>
              <p style="font-size: 14px; margin-right: auto;">
                Enter the new password below.
              </p>
            </div>
            <div style="width: 100%; color: #C7CDD6">
              <hr style="color: #5F6C81; opacity: 0.2;">
            </div>

            <ps-alert
              v-model="isPsAlertVisible"
              :dismissible="isPsAlertDismissible"
              :type="psAlertType"
              :message="psAlertmessage"
            >
              <template #default>
                <img 
                  v-if="isPsAlertVisible" 
                  :src="AlertErrorIcon" 
                  alt="Alert Icon" 
                  class="alert-icon" 
                >
              </template>
            </ps-alert>

            <div
              class="set-password-item"
              style="margin-top: -10px;"
            >
              <v-form
                class="form-set-password form"
                @keyup.native.enter="resetPassword"
              >
                <div class="input-label">
                  <label>Password</label>
                </div>
                <div class="form-field">
                  <input
                    id="newpassword"
                    v-model="password"
                    :type="passwordVisibility ? 'text' : 'password'"
                    :label="translate('label.setPassword')"
                    :error="!!error"
                    :error-messages="error"
                    outline
                    dense
                    autofocus
                    class="form-input"
                    :class="{ 'input-error': newPasswordError }"
                    :disabled="elementDisabled"
                  >
                  <span
                    class="eye-icon"
                    @click="togglePasswordVisibility"
                  > 
                    <i>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-eye"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                      </svg>
                    </i>
                  </span>
                </div>
                <div class="errorText">
                  {{ newPasswordError }}
                </div>
                <p v-if="!newPasswordError">
                  {{ translate("label.passwordRule") }}
                </p>
                <div class="input-label">
                  <label>Confirm password</label>
                </div>
                <div class="form-field">
                  <input
                    id="reenterpassword"
                    v-model="passwordReenter"
                    :type="passwordVisibility ? 'text' : 'password'"
                    :label="translate('label.reEnterPassword')"
                    :error="!!error"
                    :error-messages="error"
                    outline
                    dense
                    class="form-input"
                    :class="{ 'input-error': error }"
                    :disabled="elementDisabled"
                    @keyup.native.enter="Save"
                  >
                  <span
                    class="eye-icon"
                    @click="togglePasswordVisibility"
                  > 
                    <i>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-eye"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                      </svg>
                    </i>
                  </span>
                </div>
                <div class="errorText">
                  {{ error }}
                </div>
                <div class="form-field">
                  <ps-button
                    id="ResetPasswordButton"
                    style="margin-top: 10px;"
                    class="btn"
                    depressed
                    :disabled="elementDisabled"
                    :click="Save"
                  >
                    {{ translate("label.updatePassword") }}
                  </ps-button>
                </div>
              </v-form>
            </div>
          </div>
        </div>
      </v-app>
    </template>
    <template v-else>
      <v-layout
        align-center
        justify-center
      >
        <v-flex
          xs12
          sm8
          md4
        >
          <v-card class="elevation-12">
            <v-toolbar
              dark
              color="primary"
            >
              <v-toolbar-title>{{ this.translate("label.setPassword") }}</v-toolbar-title>
              <v-spacer />
            </v-toolbar>
            <v-card-text>
              <span v-if="CapitalRule=='True'">{{ this.translate("label.capitalRule") }}</span><br>
              <span v-if="NumberRule=='True'">{{ this.translate("label.numberRule") }}</span><br>
              <span v-if="SpecialCharacterRule=='True'">{{ this.translate("label.specialCharaterRule") }}</span><br>
              <span v-if="LengthRule!='0'">{{ this.translate("label.numberCharacter1") }}{{ LengthRule }}{{ this.translate("label.numberCharacter2") }}</span>
            </v-card-text>
            <v-card-text>
              <v-form>
                <ps-textfield
                  id="newpassword"
                  v-model="password"
                  prepend-icon="lock"
                  type="password"
                  :label="this.translate('label.setPassword')"
                  :disabled="elementDisabled"
                  outline
                />
                <ps-textfield
                  id="reenterpassword"
                  v-model="passwordReenter"
                  prepend-icon="lock"
                  type="password"             
                  :label="this.translate('label.reEnterPassword')"
                  :error="!!error"
                  :error-messages="error"
                  :disabled="elementDisabled"
                  outline
                  @keyup.native.enter="Save"
                />
                <ps-alert 
                  v-model="isPsAlertVisible"
                  :dismissible="isPsAlertDismissible"
                  :type="psAlertType" 
                  :message="psAlertmessage"              
                />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                type="submit"
                route-link="login"
                :disabled="isSaveDisabled"
                @click="Save"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </template>
  </div>
</template>


<script>   
import parseJwt from "../helperFunctions/ParseJWT";
import PsLogo from "../assets/logo.png";
import FbLogo from "../assets/social_icons/facebook.svg";
import InLogo from "../assets/social_icons/linked_in.svg";
import TwitterLogo from "../assets/social_icons/twitter.svg";
import IgLogo from "../assets/social_icons/instagram.svg";
import ProfitswordLogo from "../assets/profitsword.svg";
import NewPSLogo from "../assets/ps.svg";
import ByPSLogo from "../assets/by.svg";
import ActblPSLogo from "../assets/actbl.svg";
import AlertErrorIcon from "../assets/alert_error.svg";

export default {
    data(){
        return {        
            token: this.$router.history.current.query.t,   
            password:"",            
            passwordReenter: "",
            error: null,
            newPasswordError: null,
            isSaveDisabled: false,           
            isPsAlertVisible:false,
            isPsAlertDismissible:false,
            psAlertmessage:"",
            appUrl:"",
            psAlertType: "error",
            elementDisabled: false,
            CapitalRule: this.$router.history.current.query.CapitalRule,
            NumberRule: this.$router.history.current.query.NumberRule,
            SpecialCharacterRule: this.$router.history.current.query.SpecialCharacterRule,
            LengthRule: this.$router.history.current.query.LengthRule,     
            logo: PsLogo,
            FbLogo: FbLogo,
            InLogo: InLogo,
            TwitterLogo: TwitterLogo,
            IgLogo: IgLogo,
            ProfitswordLogo: ProfitswordLogo,
            NewPSLogo: NewPSLogo,
            ByPSLogo: ByPSLogo,
            ActblPSLogo: ActblPSLogo,
            AlertErrorIcon: AlertErrorIcon,
            passwordVisibility: false,
            useActablStyles: false,
        };
    },
    watch: {
        isPsAlertVisible(newValue) {
            if (newValue) {
                this.updateAlertIcon();
            }
        }
    },
    created()
    {      
        // Reads from url the paramenter of the new design.
        const match = window.location.href.match(/[\?&]useActablStyles=([^&]*)/);
        if (match) {
            const local = decodeURIComponent(match[1].replace(/\+/g, ""));
            this.useActablStyles = local === "Y" ? true : false;
            this.$nextTick(() => {
                // Adjust the html and body class when new design flag is active
                if (this.useActablStyles) {
                    document.documentElement.classList.add("customhtml");
                    document.body.style.background =
            "linear-gradient(64.7deg, #FFFFFF 23.24%, #E5EDFB 57.05%, #FEEADD 94.45%)";
                } else {
                    document.documentElement.classList.remove("customhtml");
                    document.body.removeAttribute("class");
                    document.body.style.background = "";
                }
            });
        }

        if (this.token == null ) { // URL did not provide a token, disable form
            this.isPsAlertVisible=true;
            this.psAlertmessage=  this.translate("label.noAuthenticationTokenProvided");
            this.isSaveDisabled =true;
            return false;
        }
        const parsedToken = parseJwt(this.token);
        const currentTime = Math.floor(Date.now()/1000);
        if (currentTime > parsedToken.exp) {
            const alertMessage = this.translate("message.PASSWORD_EMAIL_LINK_EXPIRED");
            this.$router.push({ name: "ResetPassword", params: { 
                pscg: parsedToken.psc,
                alertMessage: alertMessage,
                alertType: "error"
            }});
        }
    },
    mounted() {
        this.updateAlertIcon();
    },
    methods: {
        Save() {
        //var x;
        //this.$store.dispatch("getComplexityRules");
            const payload = {
                token: this.token,
                password: this.password,
            };

            this.isPsAlertVisible=false;
            this.psAlertmessage="";
            this.error="";
            this.newPasswordError="";

            if ((this.passwordReenter  != this.password ) || (!this.passwordReenter || !this.passwordReenter)) {
                this.error = "Passwords do not match"; // Don't bother sending to auth server if passwords don't match
                return false;
            }
       
            this.$store.dispatch("setPassword", payload).then(() => {
                this.psAlertType = "success";
                this.isPsAlertVisible = true;
                this.password = "";
                this.passwordReenter = "";
                this.elementDisabled = true;
                this.isSaveDisabled = true;
                this.isPsAlertDismissible=false;
                this.appUrl = this.$route.query.returnurl;
                let counter = 5;
                let alertMessage = this.translate("message.PASSWORD_SET_SUCCESS") + "<br /><a href='" + this.appUrl + "'>" + this.translate("message.REDIRECT_IMMEDIATELY") + "</a>";
                let countDown = () => {
                    if (counter >= 0) {
                        this.psAlertmessage = alertMessage.replace("[]", counter);
                    }
                    if(counter === 0) {
                        clearInterval(countDown);
                        window.setTimeout(function(){ window.location.href = returnUrl; }, counter*1000);
                        if (!this.appUrl.includes("http")) {
                            this.$store.dispatch("adminLogin");
                        }
                        else {
                            window.location.href = this.appUrl;
                        }
                    }
                    counter--;
                };
                countDown();
                setInterval(countDown, 1000);

            }).catch((error) => {
                if (typeof(error.response) == "undefined" || error.response.status == "404") {
                    this.psAlertType = "error";
                    this.isPsAlertVisible=true;
                    this.psAlertmessage = this.translate("message.404_ERROR");
                } 
                else {
                    this.psAlertType = "error";

                    error.response.data.forEach(element => {           
                        var splitElement = element.split(":");          
                     
                        if(splitElement.length > 1 && element.startsWith("LENGTH_VIOLATION"))
                        {
                            this.newPasswordError += this.translate("message.LENGTH_VIOLATION") + " " + splitElement[1] + ".";
                        } 
                        else if(element.startsWith("HISTORY_VIOLATION")  ) {
                            this.isPsAlertVisible=true;
                            this.psAlertmessage = this.translate("message." + splitElement[0]) + "\n";
                        }
                        else
                        {
                            this.newPasswordError += this.translate("message." + splitElement[0]) + "\n";
                        }
                    });
                }
                return;
            });        
        },
        togglePasswordVisibility() {
            this.passwordVisibility = !this.passwordVisibility;
        },
        updateAlertIcon() {
            const wrapper = document.querySelector(".v-alert__wrapper");
            if (!wrapper) return;
            const existingImg = wrapper.querySelector(".alert-icon");
            if (existingImg) {
                wrapper.removeChild(existingImg);
            }

            const iconElement = wrapper.querySelector("i.v-alert__icon");
            if (iconElement) {
                wrapper.removeChild(iconElement);
            }
            if (this.isPsAlertVisible) {
                const imgElement = document.createElement("img");
                imgElement.src = this.AlertErrorIcon;
                imgElement.alt = "Alert Icon";
                imgElement.className = "alert-icon";
                wrapper.insertBefore(imgElement, wrapper.firstChild);
            }
        }
    }
};
</script>

<style lang="scss">
@import "../styles/SetPassword.scss";
</style>